import axios from 'axios';
import { ENV } from '../env/env';

export const permissionsClient = axios.create({
  baseURL: `${ENV.REACT_APP_PERMISSIONS_URL}/api`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const privateClient = axios.create({
  baseURL: `${ENV.REACT_APP_API_URL}/api`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

privateClient.interceptors.request.use(config => {
  const token = localStorage.getItem('msal.idtoken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
